module.exports = __webpack_public_path__ + "media/svg/MyCanvas-b4a61fd7.svg";